<script setup> 
    import { computed } from 'vue';
    import AnswerRates from '@/components/result/ai-literacy-2026/AnswerRates.vue';
    import AnswerRateDistribution from '@/components/result/ai-literacy-2026/AnswerRateDistribution.vue';
    import { AREA_CODES, AREA_NAMES } from '@/components/result/ai-literacy-2026/data/reportData';
    import { detailAreasByCode } from '@/components/result/ai-literacy-2026/data/reportLogic';
    import icon01 from '@/assets/images/result/ai/icon_01.svg';
    import icon02 from '@/assets/images/result/ai/icon_02.svg';
    import icon03 from '@/assets/images/result/ai/icon_03.svg';
    import icon04 from '@/assets/images/result/ai/icon_04.svg';

    const props = defineProps({
        teacherData: Object
    });

    const icons = [icon01, icon02, icon03, icon04];
    const colors = ['#0F7EF1', '#FF889E', '#9BD380'];
    const userRole = 'teacher';

    // 우리 반 정답률 (field1_rate ~ field4_rate)
    const myPercentages = computed(() =>
        [1, 2, 3, 4].map(i => parseFloat(props.teacherData?.[`field${i}_rate`]) || 0)
    );
    // 학교 전체 정답률 (school_field1_rate ~ school_field4_rate)
    const schoolPercentages = computed(() =>
        [1, 2, 3, 4].map(i => parseFloat(props.teacherData?.[`school_field${i}_rate`]) || 0)
    );

    // 하위 영역별 정답률: field{영역}_{순번}_rate (기술 3 / 활용 3 / 윤리 3 / 인간중심 2 = 11개)
    const aiSubData = computed(() => {
        const grouped = detailAreasByCode(props.teacherData?.schul_type);
        return AREA_CODES.map((code, ai) => ({
            title: AREA_NAMES[ai],
            icon: icons[ai],
            items: (grouped[code] || []).map((label, si) => ({
                label,
                value: parseFloat(props.teacherData?.[`field${ai + 1}_${si + 1}_rate`]) || 0,
                color: colors[si % colors.length]
            }))
        }));
    });
</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap">
            <AnswerRates
                :my-percentages="myPercentages"
                :school-percentages="schoolPercentages"
                :userRole="userRole"
            />         
            <AnswerRateDistribution :sub-data="aiSubData" />
        </div>
    </div>
</template>
